export default {
  display: 'flowErrorsDisplay',
  clear: 'flowErrorsClear',
}
